import { useQuery } from "@tanstack/react-query";
import { bullMarketPeakIndicatorsQueryOptions } from "@/services/queries/coinglass/coinglassQueries";

interface UseBullMarketPeakIndicatorsParams {
  latest_only?: boolean | undefined;
  start_date?: string | undefined;
  end_date?: string | undefined;
  limit?: number | undefined;
}

export const useBullMarketPeakIndicators = (
  params?: UseBullMarketPeakIndicatorsParams
) => {
  return useQuery(bullMarketPeakIndicatorsQueryOptions(params));
};
